import { getApiClient } from '../axios-config';
import Logger from '../../../utils/logger';

/**
 * Workflow Template API Service
 * Handles API calls for the global workflow template
 */
class WorkflowTemplateAPI {
  /**
   * Get the global workflow template
   * @param {string} token - JWT authentication token
   * @returns {Promise<Array>} Array of template steps
   */
  static async getTemplate(token) {
    const apiClient = getApiClient(token);
    const response = await apiClient.get('/api/admin/workflow-template/');
    Logger.debug('WorkflowTemplateAPI.getTemplate - Response structure', {
      hasData: !!response.data?.data,
      templateCount: response.data?.data?.template?.length,
    });
    return response.data.data.template || [];
  }

  /**
   * Save/update the global workflow template
   * @param {Array} template - Array of template steps
   * @param {string} token - JWT authentication token
   * @returns {Promise<Array>} Updated template steps
   */
  static async saveTemplate(template, token) {
    const apiClient = getApiClient(token);
    const response = await apiClient.put('/api/admin/workflow-template/', {
      template,
    });
    Logger.debug('WorkflowTemplateAPI.saveTemplate - Response structure', {
      hasData: !!response.data?.data,
      templateCount: response.data?.data?.template?.length,
    });
    return response.data.data.template || [];
  }
}

export default WorkflowTemplateAPI;
